
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription-agreement",
      function () {
        return require("private-next-pages/subscription-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription-agreement"])
      });
    }
  